module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-49f00693.ttf";